const STORAGE_KEY = 'gyl_quotation_defaults_v1'

export function loadQuotationDefaults() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (!raw) return { delivery: '', invoice: '' }
		const data = JSON.parse(raw)
		if (!data || typeof data !== 'object') return { delivery: '', invoice: '' }
		return {
			delivery: data.delivery != null && data.delivery !== '' ? data.delivery : '',
			invoice: data.invoice != null && data.invoice !== '' ? data.invoice : '',
		}
	} catch (e) {
		console.warn('loadQuotationDefaults failed', e)
		return { delivery: '', invoice: '' }
	}
}

export function saveQuotationDefaults( partial ) {
	const current = loadQuotationDefaults()
	const next = {
		delivery: partial && partial.delivery !== undefined ? partial.delivery : current.delivery,
		invoice: partial && partial.invoice !== undefined ? partial.invoice : current.invoice,
	}
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
	} catch (e) {
		console.warn('saveQuotationDefaults failed', e)
	}
	return next
}

export function saveQuotationDefaultField(field, value) {
	if (field !== 'delivery' && field !== 'invoice') return loadQuotationDefaults()
	// 传空字符串表示取消该字段默认
	if (value === null || value === undefined) return loadQuotationDefaults()
	return saveQuotationDefaults({ [field]: value === '' ? '' : value })
}

/** 选项列表中是否存在该 id（兼容 number / string） */
export function optionListHasId(list, id) {
	if (id === '' || id === null || id === undefined) return false
	const arr = Array.isArray(list) ? list : []
	return arr.some(function(item) {
		return String(item && item.id) === String(id)
	})
}

/** 从选项中取出与默认值同类型的实际 id */
export function resolveOptionId(list, id) {
	const arr = Array.isArray(list) ? list : []
	const found = arr.find(function(item) {
		return String(item && item.id) === String(id)
	})
	return found ? found.id : ''
}
